module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-221.d89dd7e6.svg";